import { gql } from '@apollo/client';

export const deleteLocation = gql`
  mutation deleteLocation($id: ID!) {
    deleteLocation(id: $id) {
      value
    }
  }
`;
